export const faqs = [
  {
    "question": "What does the $27 pack include?",
    "answer": "Volume 1 contains twelve 40–45 minute lesson plans, original diagrams, instructions, school rules, safety, rotations and initial/final assessment. The five bonuses are the Rainy-Day Classroom Pack, Flag Football Festival Kit, Game-Day Math Challenges, Family Connection Kit and Achievement Certificates. The launch price is $27 USD, paid once."
  },
  {
    "question": "Who is it written for?",
    "answer": "PE teachers working with beginner students aged 10–14. Each lesson provides objectives, equipment, grouping, teacher cues, easier and harder options and observation points."
  },
  {
    "question": "Does it cover the whole school year?",
    "answer": "Yes. Teach one class a month and flag football is covered across the school year. You can also run them back to back as a unit: six weeks at two classes a week, or twelve weeks at one a week."
  },
  {
    "question": "What equipment and space will I need?",
    "answer": "Soft junior footballs, flag belts, flat markers and bibs. The reference group has 24 students; quantities, spacing and grouping depend on the activity. Assess the surface, clear margins and supervision in your own setting."
  },
  {
    "question": "Are these official flag football rules?",
    "answer": "The unit uses simplified, non-contact school adaptations. It is an independent resource and is not affiliated with the NFL or any league or governing body."
  },
  {
    "question": "Is the material in English?",
    "answer": "Yes. The lessons, printable sheets, diagrams and bonus resources are written in English."
  },
  {
    "question": "Is this a physical boxed set?",
    "answer": "No. The box image illustrates the digital pack. The resources are PDF files for screen or print; the bonuses also have editable Word versions, and the certificates have fillable PDF fields. Nothing is shipped."
  },
  {
    "question": "Do I need the bonuses to teach the lessons?",
    "answer": "No. All essential rules, safety, organization, rotations and assessment belong in the main volume. The five bonuses complement the unit."
  },
  {
    "question": "Are the previews actual pages?",
    "answer": "The gallery shows pages 10, 15, 16, 26 and 32 from the supplied Flag Football Class Ready PDF. The main 12-lesson volume is still being produced and requires review by an experienced PE teacher."
  },
  {
    "question": "Where does the checkout button take me?",
    "answer": "The button opens the Flag Football Class Ready checkout on Impultienda. This is a pre-release page: the main volume is still in production and awaits review by an experienced PE teacher. The five bonus resources are complete."
  },
  {
    "question": "What is the refund policy at release?",
    "answer": "The pack carries a 10-day money-back guarantee. Email support@stockdigital.shop within 10 days of purchase to request a refund if the pack is not right for your classes."
  }
];
